export const NO_CONSECUTIVE_CHARACTERS_LIMIT = 'NULL';
export const MAX_CONSECUTIVE_CHARACTERS_DEFAULT = 2;
export const MAX_ACCOUNT_LOGIN_ATTEMPTS_DEFAULT = '5';
export const ACCOUNT_LOGIN_ATTEMPTS_INTERVAL_MINUTES_DEFAULT = '5'
export const ACCOUNT_LOCK_DURATION_MINUTES_DEFAULT = '60';
export const APPLY_TO_SYSTEM_ADM_ACCOUNT_DEFAULT = 'true';
export const MAX_IP_ADDRESS_LOGIN_ATTEMPTS_DEFAULT = '5';
export const IP_ADDRESS_LOGIN_ATTEMPTS_INTERVAL_MINUTES_DEFAULT = '5';
export const IP_ADDRESS_BLOCK_DURATION_MINUTES_DEFAULT = '60';
